import { overrideAdminFeatureFlagByCustomerIdSlice } from './overrideDefault';
import { useDefaultAdminFeatureFlagByCustomerIdSlice } from './useDefault';

export const {
	requestPostOverrideAdminFeatureFlagByCustomerId,
	resetPostOverrideAdminFeatureFlagByCustomerId
} =
    overrideAdminFeatureFlagByCustomerIdSlice.asyncActionCreators;

export const {
	requestPostUseDefaultAdminFeatureFlagByCustomerId,
	resetPostUseDefaultAdminFeatureFlagByCustomerId
} =
    useDefaultAdminFeatureFlagByCustomerIdSlice.asyncActionCreators;
